<template>
	<div id = "map">
		<h1 class = "title"> {{$t('registerMap.title')}} </h1>
  	<gmap-map
		    :center="center"
		    :zoom="zoom"
		    class = "google-map box"
		  	>
			    <gmap-marker
			      :key="index"
			      v-for="(m, index) in markers"
			      :position="m.position"
			      :clickable="false"
			      :draggable="false"
			      @click="center=m.position"
			    ></gmap-marker>
  	</gmap-map>
	</div>			
</template>

<script>
  export default {
    data () {
      return {
				center: {lat: 45.89000, lng: 24.82910},
				zoom: window.innerWidth < 600 ? 6 : 6.6,
        markers: [{
          position: {lat: 44.43872, lng: 26.05015}
        },
				{
					position: {lat: 47.15610, lng: 27.59117}
				},
				{
					position: {lat: 44.31402, lng: 23.78265}
				},
				{
					position: {lat: 45.73685, lng: 21.22558}
				},
				{
					position: {lat: 46.75615, lng: 23.6281}
				}
				]
      }
    }
  }
</script>

<style scoped lang="scss">
.google-map {
  width: 70%;
  height:100%;
  min-height: 450px;
  margin-right: 50px;
	display: block;
	margin: auto;
}
.title {
	font-size: 35px!important;
}
#map {
  margin-top: 20px;
	margin-bottom: 20px;
}

@media screen and (max-width: 600px) {
	  .google-map {
        width: 100%;
				zoom:0.7;
    }
}
</style>